// extracted by mini-css-extract-plugin
module.exports = {"popover":"doc-popover_popover__zpBsh","popoverDisablePadding":"doc-popover_popoverDisablePadding__FE2CJ"};